import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCz4oiPxhEiIzCcl0xn528VysYdTttf8zs",
  authDomain: "dance-class-website.firebaseapp.com",
  databaseURL: "https://dance-class-website-default-rtdb.firebaseio.com",
  projectId: "dance-class-website",
  storageBucket: "dance-class-website.firebasestorage.app",
  messagingSenderId: "165596072387",
  appId: "1:165596072387:web:3a1bcb3955a1b90f8d1576"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
